import { http, HttpResponse } from 'msw'
import { StatusCodes } from 'http-status-codes'

import { allSales } from 'app/mocks/data/transactions/sales'

import { api } from 'app/utils/constants'

import {
    DisputeActionSale,
    StatusDisputeSale,
} from 'app/types/transactions/sale'

export const contactConsumer = http.post(
    `${process.env.REACT_APP_API_ADDRESS}/${api.transactions.sales.CONTACT}`,
    ({ params }) => {
        const { id } = params

        const saleFound = allSales.find((sale) => sale.id.toString() === id)

        // Not found
        if (!saleFound) {
            return HttpResponse.json(undefined, {
                status: StatusCodes.NOT_FOUND,
            })
        }

        return HttpResponse.json<DisputeActionSale>({
            id: saleFound.id,
            status_dispute: StatusDisputeSale.enum.CONTACTED,
        })
    },
)
